module.exports = __webpack_public_path__ + "img/header-bg.19957aac.svg";